import TooltipContent from './TooltipContent';
import TournamentTooltip from './TournamentTooltip';
import classNames from '@/external/classNames';
import getCdnImg from '@/shared/cdn/getCdnImg';
import Img from '@/shared/components/Img';

type Props = {
  type?: string;
  bgColor?: string;
  centerTooltip?: boolean;
  tooltipPosition?: 'bottom-start' | 'bottom-end';
  isGameBanner?: boolean;
  isCurrentTournaments?: boolean;
  translations: Record<string, string>;
  isMobile?: boolean;
};

const TournamentTypeIndicator: FC<Props> = ({
  type,
  bgColor,
  tooltipPosition,
  isGameBanner,
  isCurrentTournaments,
  translations,
  isMobile,
}) => {
  const typeTranslateString = type?.replaceAll(' ', '-');
  return (
    <div
      className="relative"
      data-testid="tournament-type"
      aria-describedby="tournament-type-tooltip"
    >
      <TournamentTooltip
        tooltipPosition={tooltipPosition}
        isCurrentTournaments={isCurrentTournaments}
        trigger={
          <Img
            alt={type ?? 'Tournament Type'}
            height={isGameBanner ? 16 : 32}
            width={isGameBanner ? 16 : 32}
            src={getCdnImg(`tournaments/icons/${typeTranslateString}.svg`)}
            className={classNames(
              'relative w-8 h-8 max-w-none cursor-pointer rounded-full shadow-[rgb(15_22_31_/10%)_0px_0px_0.75rem_0px]',
              isGameBanner && 'h-4 w-4',
              bgColor && bgColor,
            )}
          />
        }
        isMobile={isMobile}
      >
        <TooltipContent
          typeTranslateString={typeTranslateString}
          translations={translations}
        />
      </TournamentTooltip>
    </div>
  );
};

export default TournamentTypeIndicator;
